import { render, staticRenderFns } from "./DKP.vue?vue&type=template&id=d6598b14&scoped=true&"
import script from "./DKP.vue?vue&type=script&lang=js&"
export * from "./DKP.vue?vue&type=script&lang=js&"
import style0 from "./DKP.vue?vue&type=style&index=0&id=d6598b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6598b14",
  null
  
)

component.options.__file = "DKP.vue"
export default component.exports